module.exports = __webpack_public_path__ + "img/sheetdoor.a39d15c9.png";